import { Injectable } from '@angular/core';
import { CMS } from '@wiser/cms-pattern';

@Injectable()
export class CmsService extends CMS<object> {}
